export class EventsConstants {
    public static SHOW_ACCOUNTS_MODAL = "show-accounts-modal";
    public static LAUNCH_NOTIFICATION = "launch_notification";
    public static AUTHENTICATE_USER = "authenticate-user";
    public static SHOW_CONFIRMATION = "show_confirmation";
    public static HIDE_SPINNER = "hide-spinner";
    public static SHOW_SPINNER = "show-spinner";
    public static NOT_AUTHENTICATED = "not-authenticate-user";
    public static GO_TO_ROUTERLINK = "go-to-routerlink";
    public static SHOW_ERROR = "show-error";
    public static CHANGE_EXTERNAL_LANGUAGE = "change-external-lang";
    public static CHANGE_LANGUAGE_FROM_SHELL = "change-language-from-shell";
    public static INVALID_USERNAME_PASSWORD = "Invalid username or password";
    public static GET_LANGS = "get-langs";
  }
  